import { resolveImageAlt } from '@eliadmin/core/src/utils/image-alt-utils';
import Image from 'next/image';

import type { Category } from '@eliadmin/core/src/api/slugs/types/slug-detail-types';

import { cn } from '@eliadmin/core/src/utils/style-utils';
import { Paragraph } from '../ui/paragraph';

/** Anchor target of the "Zjistit více" link in `CategoryHeader`. */
export const CATEGORY_INFO_ID = 'category-info';

export function hasCategoryInfo(category?: Category) {
  return !!category?.image?.url && !!category?.description;
}

export function CategoryInfo({ category }: { category: Category }) {
  const image = category?.image?.url;
  const description = category?.description;

  if (image && description)
    return (
      <section
        id={CATEGORY_INFO_ID}
        className={cn(
          'custom-section',
          'scroll-mt-24 pb-16 pt-8 sm:pb-20 sm:pt-10 lg:pb-24 lg:pt-12',
        )}
      >
        <div
          className={cn(
            'custom-container',
            'flex flex-col items-start justify-start gap-8 md:flex-row md:items-center md:justify-between lg:gap-12',
          )}
        >
          <div className="relative aspect-square max-h-[676px] w-full overflow-hidden rounded-[4px] md:max-w-[676px]">
            <Image
              src={image}
              alt={resolveImageAlt(category?.image, category?.name)}
              fill
              className="absolute inset-0 z-0 h-full w-full object-cover object-center"
            />
          </div>
          <Paragraph
            className={cn('ea-category-info__paragraph', 'w-full')}
            size="lg"
            innerHtml={description}
          />
        </div>
      </section>
    );
}
